import styled from "@emotion/styled";

export const CustomersContactsListStyles = styled("div")`
  display: flex;
  width: 292px;
  flex-direction: column;

  height: 100%;

  background-color: #fff;

  .cl {
    position: relative;
    padding-bottom: 45px;
    padding-left: 0px !important;

    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    &__search {
      position: relative;
      display: flex;
      flex-direction: column;
      padding: 10px;
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);
    }

    &__search-wrap {
      display: flex;
    }

    &__search-result-space {
      height: 25px;
    }

    &__search-result {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 4px 10px;
      background: antiquewhite;
    }

    &__add-btn {
      display: flex;
      align-items: center;
      border: solid 1px #33c !important;
      color: #33c !important;
      height: 40px !important;
    }

    &__add-btn-text {
      color: #33c !important;
    }

    &__add-btn-icon {
      top: 3px;
    }

    &__add-btn-wrap {
      width: 93px;
      margin-left: 11px;
    }
  }
`;

export const CustomersContactsListItemStyles = styled("li")`
  position: relative;
  display: flex;
  width: 292px;
  height: 94px;
  flex-direction: column;
  border-bottom: 1px solid #e2e2ee;

  cursor: pointer;

  &:hover {
    background-color: #f6f6fa;
  }

  &.--active {
    box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.05);
    background-color: #f6f6fa;
  }

  .cli {
    &__status {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background-color: #33c;
      display: none;

      &.--active {
        display: block;
      }
    }

    &__meta {
      display: flex;
      align-items: center;
      height: 60px;
    }

    &__avatar {
      min-width: 40px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #734299;

      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      margin-left: 20px;
      overflow: hidden;
    }

    &__avatar-text {
      color: #fff;
    }

    &__name {
      width: 100%;
      font-size: 14px;
      color: #293359;
      font-weight: 500;
      margin-left: 9px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__datetime {
      color: #9499ac;
      min-width: 104px;
    }

    &__message {
      text-overflow: ellipsis;
      overflow: hidden;
      width: 250px;
      white-space: nowrap;
      color: #4a5580;
      margin-left: 20px;
    }
  }
`;

export const Notifier = styled("div")`
  position: absolute;
  bottom: 12px;
  right: 23px;
  background-color: #db7093;
  color: white;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`;
